"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePremiumCompanyProfileModalContextValue = exports.usePremiumCompanyProfileModalContextProvider = void 0;
const react_1 = __importDefault(require("react"));
const PremiumCompanyProfileModalContext = react_1.default.createContext({
    isPremiumCompanyProfileSubscriptionModalOpen: false,
    setIsPremiumCompanyProfileSubscriptionModalOpen: () => { },
});
const usePremiumCompanyProfileModalContextProvider = () => {
    const [isPremiumCompanyProfileSubscriptionModalOpen, setIsPremiumCompanyProfileSubscriptionModalOpen] = react_1.default.useState(false);
    return {
        PremiumCompanyProfileModalContextProvider: PremiumCompanyProfileModalContext.Provider,
        value: {
            isPremiumCompanyProfileSubscriptionModalOpen,
            setIsPremiumCompanyProfileSubscriptionModalOpen,
        },
    };
};
exports.usePremiumCompanyProfileModalContextProvider = usePremiumCompanyProfileModalContextProvider;
const usePremiumCompanyProfileModalContextValue = () => {
    const context = react_1.default.useContext(PremiumCompanyProfileModalContext);
    return context;
};
exports.usePremiumCompanyProfileModalContextValue = usePremiumCompanyProfileModalContextValue;
